var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prepare-index i_maxW"},[_c('div',{staticClass:"prepare-index-link"},[_c('router-link',{attrs:{"to":"/prepare"}},[_vm._v("个人备课")]),_c('router-link',{attrs:{"to":"/prepare/collective"}},[_vm._v("集体备课")])],1),_c('div',{staticClass:"prepare-index-cont"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }